import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  CloseButtonContainer,
  ModalCloseButton,
} from '../../common/components/ModalCloseButton';

import { ModalHeading, Container, StyledDialog } from './MaxImageModal';

const DialogContainer = styled(Container)`
  padding: 25px;
`;

const ReportContainer = styled.div`
  width: fit-content;
  min-width: ${p => (p.theme.isMobile ? '250px' : '500px')};
  min-height: ${p => (p.theme.isMobile ? '300px' : '600px')};
  padding: 10px;
  margin-top: 20px;
  background-color: #d9d9d9;
  white-space: pre-line;
  word-break: break-all;
`;

interface ViewReportModalProps {
  open: boolean;
  onClose: () => void;
  reportPlainText: string;
}
export const ViewReportModal = (props: ViewReportModalProps) => {
  const { open, onClose, reportPlainText } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails.report',
  });

  return (
    <StyledDialog onClose={onClose} open={open}>
      <DialogContainer>
        <CloseButtonContainer>
          <ModalCloseButton onClick={() => onClose()} />
        </CloseButtonContainer>
        <ModalHeading>{t('heading')}</ModalHeading>
        <ReportContainer>{reportPlainText}</ReportContainer>
      </DialogContainer>
    </StyledDialog>
  );
};
